export default "__VITE_ASSET__DldukDMF__"